import client from './client';
import { WaitlistEntry, WaitlistAnswers } from '../types';

export const waitlistApi = {
  submit: (answers: WaitlistAnswers) =>
    client.post<WaitlistEntry>('/waitlist', answers).then((r) => r.data),

  getMe: () =>
    client.get<WaitlistEntry>('/waitlist/me').then((r) => r.data),
};
